import { ProductSellType, ProductType } from '../enums'

// ProductSellType.Award or ProductSellType.CK should not have airline charge
// 'cardsAmmount': [4000, 7770, 300],
// total 12700
export const bug_products = [
  {
    "id": "ticket_1",
    "type": "Ticket",
    "in_house": 1000.00,
    "airline": 1000.00,
    "pre_ticket_id": 1758320,
    "sell_type": "award",
    "card_id": null
  },
  {
    "id": "ticket_2",
    "type": "Ticket",
    "in_house": 1000.00,
    "airline": 1000.00,
    "pre_ticket_id": 1758320,
    "sell_type": "award",
    "card_id": null
  },
  {
    "id": "ticket_3",
    "type": "Ticket",
    "in_house": 1000.00,
    "airline": 1000.00,
    "pre_ticket_id": 1758321,
    "sell_type": "award",
    "card_id": null
  },
  {
    "id": "ticket_4",
    "type": "Ticket",
    "in_house": 1000.00,
    "airline": 1000.00,
    "pre_ticket_id": 1758321,
    "sell_type": "award",
    "card_id": null
  },
  {
    "id": "ticket_5",
    "type": "Ticket",
    "in_house": 1000.00,
    "airline": 1000.00,
    "pre_ticket_id": 1758322,
    "sell_type": "public",
    "card_id": null
  },
  {
    "id": "ticket_6",
    "type": "Ticket",
    "in_house": 1000.00,
    "airline": 1000.00,
    "pre_ticket_id": 1758322,
    "sell_type": "public",
    "card_id": null
  }
]

// export const bug_products = [
//   {
//     'id': 'ticket_1',
//     'card_id': 'card_1',
//     'pre_ticket_id': 250,
//     'type': ProductType.Ticket,
//     'sell_type': ProductSellType.Published,
//     'in_house': 2000,
//     'airline': 2000
//   },
//   {
//     'id': 'ticket_2',
//     'card_id': 'card_2',
//     'pre_ticket_id': 250,
//     'type': ProductType.Ticket,
//     'sell_type': ProductSellType.Published,
//     'in_house': 2000,
//     'airline': 2000
//   },
//   {
//     'id': 'ticket_3',
//     'card_id': 'card_2',
//     'pre_ticket_id': 250,
//     'type': ProductType.Ticket,
//     'sell_type': ProductSellType.Published,
//     'in_house': 1500,
//     'airline': 1500
//   },
//   {
//     'id': 'insurance_110',
//     'card_id': 'card_3',
//     'pre_ticket_id': 250,
//     'type': ProductType.Insurance,
//     'sell_type': ProductSellType.Published,
//     'airline': 0,
//     'in_house': 770
//   },
//   {
//     'id': 'tips_110',
//     'card_id': 'card_3',
//     'pre_ticket_id': null,
//     'type': ProductType.Tips,
//     'sell_type': ProductSellType.Published,
//     'airline': 0,
//     'in_house': 300
//   }
// ]


export const one_big_product = [
  {
    'product_id': 'ticket_1',
    'card_id': 'card_1',
    'pre_ticket_id': 250,
    'type': ProductType.Ticket,
    'sell_type': ProductSellType.Published,
    'in_house': 1000,
    'airline': 10630
  },
  // {
  //   'id': 'insurance_1',
  //   'card_id': 'card_3',
  //   'pre_ticket_id': 250,
  //   'type': ProductType.Insurance,
  //   'sell_type': ProductSellType.Published,
  //   'airline': 0,
  //   'in_house': 770
  // },
  // {
  //   'id': 'tips_1',
  //   'card_id': 'card_3',
  //   'pre_ticket_id': null,
  //   'type': ProductType.Tips,
  //   'sell_type': ProductSellType.Published,
  //   'airline': 0,
  //   'in_house': 300
  // }
]
